import React from 'react';
import { Link } from 'react-router-dom';
import { Button, Row, Col } from 'react-bootstrap';
import { PersonCircle } from 'react-bootstrap-icons'; // For user icon
import MembershipBanner from './MembershipBanner'; // Assuming MembershipBanner is in the same components folder
import './AppHeader.css'; // Import new CSS file

const AppHeader = ({ currentUser, onLogout, onUpgradeClick }) => {
    return (
        <div className="app-header-container">
            <Row className="align-items-center justify-content-between">
                <Col xs="auto">
                    <h1 className="app-title">Finance Manager</h1>
                </Col>
                <Col xs="auto" className="d-flex align-items-center">
                    {currentUser && (
                        <span className="me-3 user-info">
                            <PersonCircle className="me-1" /> {currentUser.user_first_name || 'User'}
                        </span>
                    )}
                    {currentUser && (currentUser.role === 'ADMIN' || currentUser.role === 'MANAGER') && (
                        <Link to="/admin" className="btn btn-secondary me-2 header-btn">Admin Panel</Link>
                    )}
                    <Button variant="outline-danger" onClick={onLogout} className="header-btn">Logout</Button>
                </Col>
            </Row>
            {currentUser && !currentUser.is_premium && (
                <MembershipBanner onUpgradeClick={onUpgradeClick} />
            )}
        </div>
    );
};

export default AppHeader;
